/**
 * 记录各类操作的起始时间，并计算该Action耗时。
 * start和end必须成套操作
 */
export default class TimeRecord {
    private static timeMap = new Map<string, { startTime: number; data: any }>();

    public static start(action: string, data?: any): void {
        if (action) {
            console.log('TimeRecord: start', action, data);
            const map = this.timeMap;
            const startTime = new Date().getTime();
            map.set(action, { startTime, data });
        }
    }

    public static end(action: string): { duration: number; data?: any } | undefined {
        if (action) {
            const map = this.timeMap;
            const startObj = map.get(action);
            if (startObj) {
                map.delete(action);
                const duration = new Date().getTime() - startObj.startTime;
                console.log('TimeRecord: end', duration, startObj.data);
                return { duration, data: startObj.data };
            }
        }
    }
}
